import {SET_MOBILE} from "./styles.actions";

const setMobile = ({isMobile}) => ({type: SET_MOBILE, isMobile});

export {setMobile};
